export const environment = {
  production: false,
  groupName: "--",
  apiUrl: "https://tilmanagement-api-test.azure.chevron.com/api/v1",
  clientId: "b3d1bec4-4c84-47fa-8f0e-16389e92312c",
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  groups: {
    TurbineRoleGroups:
      "app-rat-mod-devlopers,CPL IT Business System Support Team,cgp turbine ui users",
    RamRoleGroups:
      "app-rat-mod-devlopers,CPL IT Business System Support Team,CPEM RAM Planners",
    LetterUserRoleGroups:
      "app-rat-mod-devlopers,CPL IT Business System Support Team,cpem-technical-letter-viewers",
    LetterAdminRoleGroups:
      "app-rat-mod-devlopers,CPL IT Business System Support Team,cpem-technical-letter-admins",
  },
};
